export class ExecutionSession {
  constructor(attributes = {}) {
    this.stepId = attributes.stepId || null
    this.workflowId = attributes.workflowId || null
  }

  get stepExecutionId() {
    return sessionStorage.getItem(this.stepExecutionIdKey(this.stepId, this.workflowExecutionId))
  }

  get workflowExecutionId() {
    return sessionStorage.getItem(this.workflowExecutionIdKey(this.workflowId))
  }

  set workflowExecutionId(id) {
    return sessionStorage.setItem(this.workflowExecutionIdKey(this.workflowId), id)
  }

  store(workflowId, stepId, workflowExecutionId, stepExecutionId = null) {
    sessionStorage.setItem(
      this.workflowExecutionIdKey(workflowId),
      workflowExecutionId
    )
    if (stepExecutionId !== null) {
      sessionStorage.setItem(
        this.stepExecutionIdKey(stepId, workflowExecutionId),
        stepExecutionId
      )
    } else {
      sessionStorage.removeItem(this.stepExecutionIdKey(stepId, workflowExecutionId))
    }
  }

  workflowExecutionIdKey(workflowId) {
    return `execution-session.workflow.${workflowId}.workflow-execution`
  }

  stepExecutionIdKey(stepId, workflowExecutionId) {
      return `execution-session.step.${stepId}.workflow-execution.${workflowExecutionId}.step-execution-id`
  }
}
